import { useFormContext } from 'react-hook-form'
import { Radio } from '../../shared/compass-ui'

const CashAdvanceRadioInput = () => {
  const {
    formState: { errors },
    watch,
  } = useFormContext()

  const { cashAdvance: cashAdvanceError } = errors

  const selectedValue = watch('cashAdvance')
  const hasError = typeof cashAdvanceError?.message === 'string'

  const options = [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' },
  ]

  return (
    <div
      id="cash-advance-radio-inputs-group"
      data-testid="cash-advance-radio-group"
      className={`bg-white flex flex-col rounded-md ${
        hasError ? 'border-red-600 border-2 outline-red-600 focus:border-red-600' : ''
      }`}
    >
      {options.map((option, idx) => (
        <Radio
          key={`radio-option-for-${option.value}`}
          {...option}
          idx={idx}
          hasError={hasError}
          name="cashAdvance"
          selectedValue={selectedValue}
        />
      ))}
    </div>
  )
}
export default CashAdvanceRadioInput
